export default __webpack_public_path__ + "static/media/register02.b13eebc2.png";